export enum TransactionType {
  TICKET = 'TICKET',
  CLOSE_SHIFT = 'CLOSE_SHIFT',
  MONEY_PLACEMENT = 'MONEY_PLACEMENT',
  Z_REPORT = 'Z_REPORT',
  X_REPORT = 'X_REPORT',
  OPEN_SHIFT = 'OPEN_SHIFT',
  FISCAL_REPORT = 'FISCAL_REPORT',
  CLOSE_ARCHIVE = 'CLOSE_ARCHIVE',
  RECEIPT_CORRECTION = 'RECEIPT_CORRECTION',
  CURRENT_STATE_REPORT = 'CURRENT_STATE_REPORT',
  FISCAL_REPORT_CORRECTION = 'FISCAL_REPORT_CORRECTION',
  BSO = 'BSO',
  BSO_CORRECTION = 'BSO_CORRECTION',
  CANCEL_TICKET = 'CANCEL_TICKET',
}

type TransactionPaymentType = 'transaction.ticket.payment.type.cash' | 'transaction.ticket.payment.type.card' | 'transaction.ticket.payment.type.credit' | 'transaction.ticket.payment.type.mobile' | 'transaction.ticket.payment.type.tare';
type TransactionTicketType = 'transaction.ticket.sell' | 'transaction.ticket.sell.return' | 'transaction.ticket.buy' | 'transaction.ticket.buy.return' | 'transaction.report.x' | 'transaction.report.z';
type OpenShiftDescription = string; // string format: `transaction.open.shift ${number}`
type CloseShiftDescription = string; // string format: `transaction.close.shift ${number}`
type TransactionDescription = TransactionPaymentType | TransactionTicketType | OpenShiftDescription | CloseShiftDescription;

export interface Transaction {
  cancelDate?: string; // Дата отмены
  fiscalDocumentNumber?: number; // Номер фискального документа
  fiscalId: null; // Фискальный идентификатор
  id: string; // Идентификатор транзакции
  kkmId: string; // Идентификатор ККМ
  offlineFiscalId?: string; // Офлайн фискальный идентификатор
  operationType?: number; // Тип операции
  payments: Payment[]; // Список платежей
  requestNumber?: number; // Номер запроса
  shiftNumber?: number; // Номер смены
  sum: number; // ?
  transactionDate: string; // ($date-time) Дата транзакции
  transactionDescription: TransactionDescription; // Описание транзакции
  transactionType: TransactionType; // Тип транзакции
}

export interface TicketCountItem {
  buyReturns: number;
  buys: number;
  sellReturns: number;
  sells: number;
  total: number;
}

export interface Payment {
  paymentType: PaymentType; // Тип платежа
  sum: number; // Сумма платежа
  count: number;
}

export type PaymentType = 'CASH' | 'CARD' | 'CREDIT' | 'TARE' | 'MOBILE' | 'UNKNOWN';

export interface Report {
  cash: number;
  id: string;
  nonNullableSums: {
    sells: number;
    sellReturns: number;
    buy: number;
    buyReturns: number;
    nonNullableSum: number;
  };
  revenue: number;
  shiftNumber: number;
  ticketCount: TicketCountItem;
  ticketOperations?: TicketOperationItem[];
  transactionDate: string;
  type: 0 | 1;
}

export interface TicketOperationItem {
  type: 'SELL' | 'SELL_RETURN' | 'BUY' | 'BUY_RETURN';
  totalTicketsCount: number;
  ticketsCount: number;
  sum: number;
  payments: Payment[];
}
